var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckNot = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline / Messages, Conversation / Check Read"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9112 5.77919C13.1712 6.00619 13.198 6.40102 12.971 6.66104L6.42338 14.161C6.30469 14.297 6.13302 14.375 5.95255 14.375C5.77208 14.375 5.60042 14.297 5.48173 14.161L2.86268 11.161C2.63567 10.901 2.66244 10.5062 2.92247 10.2792C3.1825 10.0522 3.57732 10.0789 3.80433 10.339L5.95255 12.7997L12.0293 5.83897C12.2564 5.57894 12.6512 5.55218 12.9112 5.77919Z",
    fill: "#9499AB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.098 5.84955C17.348 6.08761 17.3576 6.48322 17.1196 6.73317L9.97651 14.2332C9.85027 14.3657 9.67227 14.4363 9.4895 14.4262C9.30673 14.4161 9.13757 14.3264 9.02668 14.1808L8.66975 13.712C8.46063 13.4374 8.51374 13.0452 8.78836 12.8361C9.02428 12.6565 9.34694 12.6704 9.56578 12.852L16.2144 5.87109C16.4525 5.62114 16.8481 5.61149 17.098 5.84955Z",
    fill: "#9499AB"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckNot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkNot.455fc796fb319b53afca23c5a4e4699d.svg";